import type { TDatadogErrorLog } from 'utils/datadog/types'

export const LOAD_DASHBOARD_FOLDER_HEADER_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/dashboard-folder-header',
  name: 'Loads Dashboard Folder header info',
  message: 'Failed to load the Dashboard Folders header info',
}
